import * as React from 'react';
import { IWidget } from 'common/schema/widget/Widget';
import { useRequestCompileContext } from 'client/components/schema/requests/compile-context/RequestCompileContext';
import { IRequestListRow } from 'common/schema/request/Request';
import { Draggable } from 'react-beautiful-dnd';
import { WidgetInputRowContent } from './WidgetInputRowContent';

interface WidgetInputRowProps {
  widget: IWidget;
  index: number;
  handleAdd: any;
  handleRemove: any;
  row?: IRequestListRow;
}

/**
 * Singola riga del widget a preferenza multipla
 */
export function WidgetInputRow(props: WidgetInputRowProps) {
  const { index, widget, handleAdd, handleRemove, row } = props;
  const { request } = useRequestCompileContext();

  const cascade = widget.input!.extra?.cascade;

  if (!cascade) return null;

  return (
    <Draggable key={index} draggableId={String('field-' + index)} index={index}>
      {(provided, _) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          <WidgetInputRowContent
            widget={widget}
            request={request}
            row={row}
            handleAdd={handleAdd}
            handleRemove={handleRemove}
            index={index}
            cascade={cascade}
          />
        </div>
      )}
    </Draggable>
  );
}
